import API from '~config/api';
import {
  ApiPromise,
  PaginationRequestParams,
  DataResponse,
  DataPaginateResponse,
  ErrorResponse,
} from '~globals/types';

import { ApiTransactionExtended } from '../apiTransaction/types';
import {
  ScheduleRouteRepetionExtended,
  ScheduleRouteFilter,
  ScheduleRouteExtended,
  ScheduleRouteUpdateBody,
  ScheduleRouteEnabledParams,
  ScheduleRouteDeleteParams,
} from './types';

const SCHEDULE_ROUTE_ENPOINTS = {
  createScheduleRoute: '/api/v1/Route/RouteSchedule/CreateRouteSchedule',
  searchScheduleRoutes: '/api/v1/Route/RouteSchedule/search',
  getScheduleRouteById: (routeScheduleId: string): string =>
    `/api/v1/Route/RouteSchedule/${routeScheduleId}`,
  updateScheduleRoute: '/api/v1/Route/RouteSchedule/UpdateRouteSchedule',
  enabledScheduleRoute: '/api/v1/Route/RouteSchedule/Enabled',
  deleteScheduleRoutes: '/api/v1/Route/RouteSchedule/Delete',
};

export const createScheduleRoute = (
  body: ScheduleRouteRepetionExtended,
): ApiPromise<DataResponse<ApiTransactionExtended>, ErrorResponse> =>
  API.post<DataResponse<ApiTransactionExtended>, ErrorResponse>(
    SCHEDULE_ROUTE_ENPOINTS.createScheduleRoute,
    body,
  );

export const searchScheduleRoutes = ({
  pagination: { page, sizePerPage },
  filters,
}: PaginationRequestParams<ScheduleRouteFilter>): ApiPromise<
  DataPaginateResponse<ScheduleRouteExtended[]>,
  ErrorResponse
> =>
  API.post<DataPaginateResponse<ScheduleRouteExtended[]>, ErrorResponse>(
    SCHEDULE_ROUTE_ENPOINTS.searchScheduleRoutes,
    {
      ...filters,
      pagination: {
        offset: page,
        size: sizePerPage,
      },
    },
  );

export const getScheduleRouteById = (
  routeScheduleId: string,
): ApiPromise<DataResponse<ScheduleRouteExtended>, ErrorResponse> =>
  API.get<DataResponse<ScheduleRouteExtended>, ErrorResponse>(
    SCHEDULE_ROUTE_ENPOINTS.getScheduleRouteById(routeScheduleId),
  );

export const updateScheduleRoute = (
  body: ScheduleRouteUpdateBody,
): ApiPromise<DataResponse<null>, ErrorResponse> =>
  API.put<DataResponse<null>, ErrorResponse>(
    SCHEDULE_ROUTE_ENPOINTS.updateScheduleRoute,
    body,
  );

export const enabledScheduleRoute = (
  body: ScheduleRouteEnabledParams,
): ApiPromise<DataResponse<null>, ErrorResponse> =>
  API.put<DataResponse<null>, ErrorResponse>(
    SCHEDULE_ROUTE_ENPOINTS.enabledScheduleRoute,
    body,
  );

export const deleteScheduleRoutes = (
  body: ScheduleRouteDeleteParams,
): ApiPromise<DataResponse<null>, ErrorResponse> =>
  API.post<DataResponse<null>, ErrorResponse>(
    SCHEDULE_ROUTE_ENPOINTS.deleteScheduleRoutes,
    body,
  );
